import {
  appendCurrentDomainPrefix, libInit, sendGoogleEvent, sendRequest,
} from 'html/include/pw/_common/utils';
import AMCommonMonthSelector from '@atomic/molecules/_common/month-selector/month-selector';
import StickyMenu from '@scout/components/sticky-menu';
import AOPaxTravelers from '@atomic/organisms/_common/pax-selector/travelers/pax-travelers';
import AOPaxTravelersMenu from '@atomic/organisms/_common/pax-selector/travelers/menu/pax-travelers-menu';

const EVENT_CATEGORY = 'Deals Page';
const results = [];
const DEPARTURES_CONTAINER = '.js-ao-clp-sale-hero__when';
const DEPARTURES_OPTION_SELECTOR = '.js-month-option';
const DESTINATION_DROPDOWN_SELECTOR = '.autocomplete-list.pre';
const SEARCH_WRAPPER_CLASS_JS = '.js-ao-clp-sale-hero__search';
const CTA_CLASS_JS = '.js-ao-clp-sale-hero__cta';

export default function AOClpSaleSearch() {
  const stickyMenuTravelers = new StickyMenu({ selector: '.js-ao-pax-travelers-sheet' });
  const paxTravelers = new AOPaxTravelers(stickyMenuTravelers);
  const paxTravelersMenu = new AOPaxTravelersMenu(true);

  let $destinationsInput;
  let inputFirstClick;
  let $searchBlock;
  let $defaultSuggestions;
  let openedFullSearchDropdown = false;
  let $ctaButton = null;
  let $departuresInput = null;
  let $departuresDropdown = null;
  let renderSuggestedList = null;

  const enableMonth = () => {
    $(DEPARTURES_CONTAINER).removeClass('ao-clp-sale-hero__second--disabled');
    $departuresInput
      .prop('disabled', false);
  };

  const getDiscountSpan = (discount) => {
    if (!discount) return '';

    return `<span class="ao-clp-sale-hero__search-discount">${discount}</span>`;
  };

  const disableMonths = () => {
    $(DEPARTURES_CONTAINER).addClass('ao-clp-sale-hero__second--disabled');
    $departuresInput
      .prop('disabled', 'disabled');
  };

  const toggleDestinationDropdown = (toggle) => {
    if (inputFirstClick) {
      renderSuggestedList();
      return;
    }

    if (toggle) $defaultSuggestions.find('.active').removeClass('active');

    $('.autocomplete-list:not(.pre)').toggle(!toggle);

    $defaultSuggestions.toggle(toggle);
    $defaultSuggestions.toggleClass('hid', !toggle);
    $destinationsInput.toggleClass('ao-clp-sale-hero__first-input--active', toggle);
    openedFullSearchDropdown = toggle;
  };

  const invokeDestinationError = () => {
    toggleDestinationDropdown(true);
    $destinationsInput.addClass('ao-clp-sale-hero__first-input--error');
  };

  const handleMonthDisplay = (html) => {
    $departuresDropdown.empty().append(html);

    new AMCommonMonthSelector().initiate({
      $container: $departuresDropdown,
      $input: $departuresInput,
    });

    $departuresDropdown.find('.js-am-month-selector__month').each((idx, el) => {
      const $el = $(el);

      $el.addClass('js-month-option');
      $el.removeClass('am-month-selector__month--active');
    });
  };

  const validateDestinationInput = (destination) => {
    const typedAttempt = $destinationsInput.val();

    if (!destination && !typedAttempt) {
      sendGoogleEvent(EVENT_CATEGORY, 'Error Message', 'Nothing Selected');

      invokeDestinationError();

      return false;
    }

    if (!destination && typedAttempt) {
      sendGoogleEvent(EVENT_CATEGORY, 'Error Message', `Destination Not Selected - ${typedAttempt}`);

      invokeDestinationError();

      return false;
    }

    return true;
  };

  const getListFromSelect = () => {
    const $destinationsSelect = $('.js-ao-clp-sale-hero__search-select');
    const $destinationsOption = $('.js-ao-clp-sale-hero__search-option');

    if ($destinationsSelect.length === 0) return;

    $destinationsOption.forEach((option) => {
      const $option = $(option);
      results.push({
        id: $option.val(),
        title: $option.text().trim(),
        link: $option.data('url'),
        discount: getDiscountSpan($option.data('discount')),
      });
    });
  };

  const toggleDeparturesDropdown = (toggle, reset) => {
    const placeholder = $departuresInput.attr('placeholder');

    if ($departuresDropdown.hasClass('active') && toggle) return;

    if (reset) {
      $departuresInput.val(placeholder);
      $departuresInput.data('departure', 'unselected');
    }

    $departuresDropdown.find('.js-am-month-selector__wrapper').toggleClass('hid', !toggle);
    $departuresInput.toggleClass('ao-clp-sale-hero__second-input--active', toggle);
  };

  const changeMonth = () => {
    if (!$departuresInput.data('departure')) return;

    $departuresInput.on('click', () => toggleDeparturesDropdown(true));

    $('body').on('click', DEPARTURES_OPTION_SELECTOR, (event) => {
      const $clickedMonth = $(event.currentTarget);
      const clickedMonthLabel = $clickedMonth.data('label');
      const clickedMonthValue = $clickedMonth.data('value');

      $departuresInput.val(clickedMonthLabel);
      $departuresInput.data('departure', clickedMonthValue);

      $clickedMonth.addClass('active');
      $clickedMonth.siblings().removeClass('active');

      toggleDestinationDropdown(false);
      toggleDeparturesDropdown(false);

      sendGoogleEvent(
        EVENT_CATEGORY,
        'Month Selected',
        clickedMonthValue,
      );
    });
  };

  const onCountrySelect = (id, url, label) => {
    $destinationsInput.data('id', id);
    $destinationsInput.val(label);
    $destinationsInput.data('url', url);

    $departuresDropdown.find('li').slice(0).remove();
    $departuresInput.addClass('ao-clp-sale-hero__second-input--disabled');
    $destinationsInput.removeClass('ao-clp-sale-hero__first-input--active');

    toggleDeparturesDropdown(false, true);
    disableMonths();

    sendRequest(
      '/api/deals/search',
      {
        page_id: id,
      },
      (data) => {
        if (data.status === 'OK') {
          $departuresInput.data('departure', 'unselected');

          if (data.html === '') {
            const emptyDateLabel = $('.js-ao-clp-sale-hero__when').data('no-dates');
            $departuresInput.val(emptyDateLabel);
            $departuresInput.data('url', false);
          } else {
            const placeholderLabel = $departuresInput.val();

            $departuresInput.val(placeholderLabel);
            $departuresInput.removeClass('ao-clp-sale-hero__second-input--disabled');

            handleMonthDisplay(data.html);
            enableMonth();
            changeMonth();
          }
        }
      },
    );

    sendGoogleEvent(
      EVENT_CATEGORY,
      'Destination Selected',
      label,
    );
  };

  const hideOnOutsideClick = () => {
    $(document).on('click', (event) => {
      if (!$defaultSuggestions.hasClass('hid') && !$searchBlock.find(event.target).length) {
        toggleDestinationDropdown(false);
        $defaultSuggestions.toggleClass('hid');
      }

      if ($departuresDropdown.hasClass('active') && !$searchBlock.find(event.target).length) {
        toggleDeparturesDropdown(false);
        $defaultSuggestions.toggleClass('active', false);
      }
    });
  };

  renderSuggestedList = () => {
    const $autocompleteWrapper = $('<ul class="autocomplete-list pre"></ul>');

    results.forEach((item) => {
      const itemDiscountSpan = getDiscountSpan(item.discount);

      $autocompleteWrapper.append(`
        <li class="autocomplete-item ao-clp-sale-hero__search-item">
          <span class="js-ao-clp-sale-hero__search-link ao-clp-sale-hero__search-link" data-id="${item.id}" data-url="${item.link}">${item.title}</span>
          ${itemDiscountSpan}
        </li>`);
    });

    $('.autocomplete').append($autocompleteWrapper);
    inputFirstClick = false;

    $defaultSuggestions = $searchBlock.find(DESTINATION_DROPDOWN_SELECTOR);
    hideOnOutsideClick();
  };

  const onCtaClick = () => {
    $ctaButton.click(() => {
      const destination = $destinationsInput.data('url');
      const departure = $departuresInput.data('departure');

      if (validateDestinationInput(destination)) {
        const hasDepartureDate = departure && departure !== 'unselected';
        const url = destination + (hasDepartureDate ? `#month=${departure}` : '');
        const adultPaxCount = $('.js-ao-pax-travelers').attr('data-pax-adults');
        const childrenPaxCount = $('.js-ao-pax-travelers').attr('data-pax-children');

        let travelers = '';

        if (adultPaxCount) {
          travelers = `${hasDepartureDate ? ',' : '#'}adults=${adultPaxCount}`;
        }
        if (childrenPaxCount) {
          travelers = `${travelers},children=${childrenPaxCount}`;
        }

        window.location.href = `${url}${travelers}`;
        sendGoogleEvent(EVENT_CATEGORY, 'View Deal Click', url, {
          blockName: 'clp-hero-with-search',
          searchTerm: $destinationsInput.val(),
          searchTime: departure,
          adultPaxCount,
          childrenPaxCount,
          ampEventName: 'on_site_search_completed',
        });
      }
    });
  };

  const initSelect = () => {
    const noResultsLabel = $('.js-ao-clp-sale-hero__search-input-wrapper').data('no-results');

    libInit('autocomplete', () => {
      $destinationsInput.prop('readOnly', false);

      $destinationsInput.tinyAutocomplete({
        wrapClasses: 'ao-clp-sale-hero__search-list',
        data: results,
        minChars: 3,
        itemTemplate: '<li class="autocomplete-item ao-clp-sale-hero__search-item"><span class="js-ao-clp-sale-hero__search-link ao-clp-sale-hero__search-link" data-id="{{id}}" data-url="{{link}}">{{title}}</span>{{discount}}</li>',
        showNoResults: true,
        noResultsTemplate: `<li class="autocomplete-item ao-clp-sale-hero__search-item ao-clp-sale-hero__search-item--no-results">${noResultsLabel}: {{title}}</li>`,
        markAsBold: false,
        onSelect: (element) => {
          const $elementSearchLink = $(element).find('.js-ao-clp-sale-hero__search-link');
          const elementId = $elementSearchLink.data('id');
          let elementUrl = $elementSearchLink.data('url');
          const elementLabel = $elementSearchLink.text().trim();

          if (!elementLabel || !elementId || !elementUrl) {
            return;
          }

          elementUrl = appendCurrentDomainPrefix(elementUrl);

          onCountrySelect(elementId, elementUrl, elementLabel);
        },
      }).on('click', () => {
        if (openedFullSearchDropdown) {
          return;
        }

        toggleDestinationDropdown(true);
      }).on('keydown keypress change focus input', (event) => {
        const inputEmpty = $(event.currentTarget).val().length === 0;
        toggleDestinationDropdown(inputEmpty);
        $destinationsInput.removeClass('ao-clp-sale-hero__first-input--error');
      });
    });
  };

  const initiate = () => {
    $searchBlock = $(SEARCH_WRAPPER_CLASS_JS);
    $ctaButton = $(CTA_CLASS_JS);
    $destinationsInput = $('.js-ao-clp-sale-hero__search-input');
    $departuresInput = $('.js-ao-clp-sale-hero__when-input');
    $departuresDropdown = $('.js-ao-clp-sale-hero__when-dropdown');

    if ($searchBlock.length === 0) return;

    inputFirstClick = true;

    getListFromSelect();
    onCtaClick();

    disableMonths();

    initSelect();

    stickyMenuTravelers.initiateWithoutOpening();
    paxTravelers.initiate();
    paxTravelersMenu.initiate();
  };

  return { initiate };
}
